import { TransactingToolType } from './models/transacting-tool';

export enum TransactionEvents {
  Navigation = 'yoop-transaction-navigation',
  Complete = 'yoop-transaction-complete',
  Claim = 'yoop-transaction-claim',
  Cancel = 'yoop-transaction-cancel',
}

enum RequestMarketplace {
  MyPriceOffer = 'myPriceOffer',
}

export const TransactionType = { ...TransactingToolType, ...RequestMarketplace };
export type TransactionType = (typeof TransactionType)[keyof typeof TransactionType];

export enum TransactionMode {
  Edit = 'edit',
  Transaction = 'transaction',
  Claim = 'claim',
}

interface TransactionAction<T = any> {
  action: TransactionEvents;
  data: T;
}

export type TransactionCompleteData<T = any> = { type: TransactionType; id: string; data?: T };
interface TransactionNavigationData {
  step: string;
  marketplaceId: string;
  eventId: string;
  mode: string;
  offerGroupId: string;
}
export enum ClaimResult {
  Claimed = 'claimed',
  Declined = 'declined',
  Failed = 'failed',
}
export interface TransactionClaimData {
  result: ClaimResult;
}
export type TransactionCompleteAction = TransactionAction<TransactionCompleteData>;
export type TransactionClaimAction = TransactionAction<TransactionClaimData>;
export type TransactionNavigationAction = TransactionAction<TransactionNavigationData>;
export type TransactionActions =
  | TransactionCompleteAction
  | TransactionNavigationAction
  | { action: Exclude<string, TransactionEvents> };
